module.exports = __webpack_public_path__ + "img/navigation-pointer-off-01.3a392512.svg";